(function () {
  function init(root) {
    if (!root) return;
    var tabs = root.querySelectorAll(".overlay-tab");
    var beautySubnav = root.querySelector(".overlay-subnav--beauty");
    var headerEl = root.querySelector(".overlay-header");
    var tablistEl = root.querySelector(".overlay-tablist");
    var subnavEl = root.querySelector(".overlay-subnav");

    function setHeights() {
      if (headerEl)
        root.style.setProperty(
          "--overlay-header-height",
          headerEl.getBoundingClientRect().height + "px"
        );
      if (tablistEl)
        root.style.setProperty(
          "--overlay-tabs-height",
          tablistEl.offsetHeight + "px"
        );
      if (!subnavEl || !subnavEl.classList.contains("forced")) {
        root.style.setProperty("--dynamic-subnav-offset", "0px");
      }
      var offset = 0;
      if (headerEl) offset += headerEl.offsetHeight;
      if (tablistEl) offset += tablistEl.offsetHeight;
      if (subnavEl && subnavEl.classList.contains("show"))
        offset += subnavEl.offsetHeight;
      root.style.setProperty("--sidebar-offset", offset + "px");
    }
    function handleSticky() {
      if (!headerEl || !tablistEl) return;
      var tabsTop = tablistEl.getBoundingClientRect().top;
      if (tabsTop <= 0) {
        headerEl.style.position = "sticky";
        headerEl.style.top = "0px";
        headerEl.style.zIndex = "61";
        root.style.setProperty(
          "--overlay-header-height",
          headerEl.getBoundingClientRect().height + "px"
        );
        root.classList.add("is-stuck");
        var activeTab = root.querySelector(".overlay-tab.is-active");
        var isBeauty =
          activeTab && activeTab.textContent.trim().toLowerCase() === "beauty";
        if (isBeauty && subnavEl && subnavEl.classList.contains("show")) {
          root.style.setProperty(
            "--dynamic-subnav-offset",
            subnavEl.offsetHeight + "px"
          );
        } else {
          root.style.setProperty("--dynamic-subnav-offset", "0px");
        }
      } else {
        headerEl.style.position = "";
        headerEl.style.top = "";
        headerEl.style.zIndex = "";
        root.style.removeProperty("--overlay-header-height");
        root.classList.remove("is-stuck");
        root.style.setProperty("--dynamic-subnav-offset", "0px");
      }
      setHeights();
    }
    document.addEventListener(
      "scroll",
      function () {
        handleSticky();
        setHeights();
      },
      { passive: true }
    );
    window.addEventListener("resize", setHeights);
    setHeights();
    handleSticky();

    tabs.forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        tabs.forEach(function (x) {
          x.classList.remove("is-active");
        });
        this.classList.add("is-active");
        var label = this.textContent.trim().toLowerCase();

        var subLinks = root.querySelectorAll(".overlay-subnav-link");
        subLinks.forEach(function (x) {
          x.classList.remove("is-active");
          x.setAttribute("aria-selected", "false");
        });
        var categoryLink = Array.from(subLinks).find(function (x) {
          return x.textContent.trim().toLowerCase() === "category";
        });
        if (categoryLink) {
          categoryLink.classList.add("is-active");
          categoryLink.setAttribute("aria-selected", "true");
        }

        var brandView = root.querySelector(".brand-view");
        var servicesView = root.querySelector(".services-view");
        var luxView = root.querySelector(".lux-view");
        var categoriesLayoutBeauty = root.querySelector(".layout-beauty");
        var categoriesLayoutHealth = root.querySelector(".layout-health");
        var luxSubnav = root.querySelector(".lux-subnav");
        var healthSubnav = root.querySelector(".health-subnav");

        brandView && brandView.setAttribute("hidden", "");
        servicesView && servicesView.setAttribute("hidden", "");
        luxView && luxView.setAttribute("hidden", "");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.setAttribute("hidden", "");

        if (label === "lux." || label === "lux") {
          luxView && luxView.removeAttribute("hidden");
          beautySubnav && beautySubnav.classList.remove("show");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.removeAttribute("hidden");
          root.classList.add("is-lux");
          root.classList.remove("is-health");
          var start = performance.now();
          function step() {
            root.style.setProperty(
              "--overlay-header-height",
              headerEl.getBoundingClientRect().height + "px"
            );
            if (performance.now() - start < 480) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        } else if (label === "health+" || label === "health") {
          categoriesLayoutHealth &&
            categoriesLayoutHealth.removeAttribute("hidden");
          beautySubnav && beautySubnav.classList.remove("show");
          healthSubnav && healthSubnav.removeAttribute("hidden");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
          root.classList.add("is-health");
          root.classList.remove("is-lux");
          var start2 = performance.now();
          function step2() {
            root.style.setProperty(
              "--overlay-header-height",
              headerEl.getBoundingClientRect().height + "px"
            );
            if (performance.now() - start2 < 480) requestAnimationFrame(step2);
          }
          requestAnimationFrame(step2);
        } else {
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.removeAttribute("hidden");
          beautySubnav && beautySubnav.classList.add("show");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
          root.classList.remove("is-health");
          root.classList.remove("is-lux");
          var start3 = performance.now();
          function step3() {
            root.style.setProperty(
              "--overlay-header-height",
              headerEl.getBoundingClientRect().height + "px"
            );
            if (performance.now() - start3 < 480) requestAnimationFrame(step3);
          }
          requestAnimationFrame(step3);
        }

        root.querySelectorAll(".categories-content").forEach(function (sc) {
          sc.scrollTop = 0;
        });
        var brandList = root.querySelector(".brand-list");
        if (brandList) brandList.scrollTop = 0;

        setHeights();
        handleSticky();
      });
    });

    var subnavLinks = root.querySelectorAll(".overlay-subnav-link");
    var brandView = root.querySelector(".brand-view");
    var servicesView = root.querySelector(".services-view");
    var luxView = root.querySelector(".lux-view");
    var healthSubnav = root.querySelector(".health-subnav");
    var luxSubnav = root.querySelector(".lux-subnav");
    var categoriesLayoutBeauty = root.querySelector(".layout-beauty");
    var categoriesLayoutHealth = root.querySelector(".layout-health");
    subnavLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        var topActive = root.querySelector(".overlay-tab.is-active");
        var topLabel = topActive
          ? topActive.textContent.trim().toLowerCase()
          : "beauty";
        if (topLabel !== "beauty") return;
        subnavLinks.forEach(function (x) {
          x.classList.remove("is-active");
          x.setAttribute("aria-selected", "false");
        });
        this.classList.add("is-active");
        this.setAttribute("aria-selected", "true");
        var label = this.textContent.trim().toLowerCase();
        if (label === "brands") {
          brandView && brandView.removeAttribute("hidden");
          servicesView && servicesView.setAttribute("hidden", "");
          luxView && luxView.setAttribute("hidden", "");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.setAttribute("hidden", "");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
        } else if (label === "services") {
          brandView && brandView.setAttribute("hidden", "");
          servicesView && servicesView.removeAttribute("hidden");
          luxView && luxView.setAttribute("hidden", "");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.setAttribute("hidden", "");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
        } else if (label === "lux." || label === "lux") {
          brandView && brandView.setAttribute("hidden", "");
          servicesView && servicesView.setAttribute("hidden", "");
          luxView && luxView.removeAttribute("hidden");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.setAttribute("hidden", "");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.removeAttribute("hidden");
        } else if (label === "health+" || label === "health") {
          brandView && brandView.setAttribute("hidden", "");
          servicesView && servicesView.setAttribute("hidden", "");
          luxView && luxView.setAttribute("hidden", "");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.removeAttribute("hidden");
          healthSubnav && healthSubnav.removeAttribute("hidden");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
        } else if (label === "beauty") {
          brandView && brandView.setAttribute("hidden", "");
          servicesView && servicesView.setAttribute("hidden", "");
          luxView && luxView.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.setAttribute("hidden", "");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.removeAttribute("hidden");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
        } else {
          brandView && brandView.setAttribute("hidden", "");
          servicesView && servicesView.setAttribute("hidden", "");
          luxView && luxView.setAttribute("hidden", "");
          categoriesLayoutHealth &&
            categoriesLayoutHealth.setAttribute("hidden", "");
          categoriesLayoutBeauty &&
            categoriesLayoutBeauty.removeAttribute("hidden");
          healthSubnav && healthSubnav.setAttribute("hidden", "");
          luxSubnav && luxSubnav.setAttribute("hidden", "");
        }
      });
    });

    (function initTabState() {
      var active = root.querySelector(".overlay-subnav-link.is-active");
      var label = active ? active.textContent.trim().toLowerCase() : "category";
      var topActive = root.querySelector(".overlay-tab.is-active");
      var topLabel = topActive
        ? topActive.textContent.trim().toLowerCase()
        : "beauty";
      var luxSubnav = root.querySelector(".lux-subnav");
      var healthSubnav = root.querySelector(".health-subnav");
      if (topLabel === "lux." || topLabel === "lux") {
        root.classList.add("is-lux");
        luxSubnav && luxSubnav.removeAttribute("hidden");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
      } else if (topLabel === "health+" || topLabel === "health") {
        root.classList.add("is-health");
        healthSubnav && healthSubnav.removeAttribute("hidden");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
      } else {
        root.classList.remove("is-health");
        root.classList.remove("is-lux");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
      }
      if (label === "brands") {
        brandView && brandView.removeAttribute("hidden");
        servicesView && servicesView.setAttribute("hidden", "");
        luxView && luxView.setAttribute("hidden", "");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.setAttribute("hidden", "");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
      } else if (label === "services") {
        brandView && brandView.setAttribute("hidden", "");
        servicesView && servicesView.removeAttribute("hidden");
        luxView && luxView.setAttribute("hidden", "");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.setAttribute("hidden", "");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
      } else if (label === "lux." || label === "lux") {
        brandView && brandView.setAttribute("hidden", "");
        servicesView && servicesView.setAttribute("hidden", "");
        luxView && luxView.removeAttribute("hidden");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.setAttribute("hidden", "");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
        luxSubnav && luxSubnav.removeAttribute("hidden");
      } else if (label === "health+" || label === "health") {
        brandView && brandView.setAttribute("hidden", "");
        servicesView && servicesView.setAttribute("hidden", "");
        luxView && luxView.setAttribute("hidden", "");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.removeAttribute("hidden");
        healthSubnav && healthSubnav.removeAttribute("hidden");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
      } else {
        brandView && brandView.setAttribute("hidden", "");
        servicesView && servicesView.setAttribute("hidden", "");
        luxView && luxView.setAttribute("hidden", "");
        categoriesLayoutHealth &&
          categoriesLayoutHealth.setAttribute("hidden", "");
        categoriesLayoutBeauty &&
          categoriesLayoutBeauty.removeAttribute("hidden");
        healthSubnav && healthSubnav.setAttribute("hidden", "");
        luxSubnav && luxSubnav.setAttribute("hidden", "");
      }
    })();

    var servicesOverlay = root.querySelector(".coming-soon-overlay");
    root.querySelectorAll(".services-view .service-link").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        if (servicesOverlay) {
          servicesOverlay.style.display = "flex";
          setTimeout(function () {
            servicesOverlay.style.display = "none";
          }, 1300);
        }
      });
    });
    var brandInput = root.querySelector('input[id^="brandSearchInput-"]');
    var brandClear = root.querySelector(".brand-search-clear");
    var brandItems = root.querySelectorAll(".brand-item");
    function filterBrands() {
      var q = ((brandInput && brandInput.value) || "").trim().toLowerCase();
      brandItems.forEach(function (item) {
        var name = item.getAttribute("data-brand") || "";
        item.style.display = q === "" || name.indexOf(q) > -1 ? "" : "none";
      });
      if (brandClear) brandClear.hidden = !(brandInput && brandInput.value);
    }
    brandInput && brandInput.addEventListener("input", filterBrands);
    brandClear &&
      brandClear.addEventListener("click", function () {
        if (brandInput) {
          brandInput.value = "";
          filterBrands();
          brandInput.focus();
        }
      });

    var sidebarLinks = root.querySelectorAll(".root-link");
    var panels = root.querySelectorAll(".category-panel");
    var contentScroller = root.querySelector(".categories-content");
    sidebarLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        var redirectFlag =
          (root.getAttribute("data-redirect-to-link") || "false") === "true";
        if (!redirectFlag) e.preventDefault();
        var idx = this.getAttribute("data-index");
        sidebarLinks.forEach(function (a) {
          a.classList.remove("active");
        });
        this.classList.add("active");
        root.querySelectorAll(".group-nav-item").forEach(function (li) {
          li.classList.remove("activated");
          li.querySelector(".root-link") &&
            li
              .querySelector(".root-link")
              .setAttribute("aria-pressed", "false");
        });
        this.closest(".group-nav-item") &&
          this.closest(".group-nav-item").classList.add("activated");
        this.setAttribute("aria-pressed", "true");
        var target = root.querySelector("#panel-" + idx);
        if (target) {
          var wrapper = contentScroller;
          var targetTop =
            target.getBoundingClientRect().top -
            wrapper.getBoundingClientRect().top +
            wrapper.scrollTop -
            8;
          wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
          target.classList.remove("highlight");
          void target.offsetWidth;
          target.classList.add("highlight");
        }
      });
    });

    var io;
    function setupObserver() {
      if (!contentScroller) return;
      if (io) {
        try {
          io.disconnect();
        } catch (e) {}
      }
      io = new IntersectionObserver(
        function (entries) {
          var topMost = null;
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            if (
              !topMost ||
              en.boundingClientRect.top < topMost.boundingClientRect.top
            )
              topMost = en;
          });
          if (!topMost) return;
          var idx = topMost.target.getAttribute("data-index");
          sidebarLinks.forEach(function (a) {
            a.classList.remove("active");
            a.setAttribute("aria-pressed", "false");
          });
          var left = root.querySelector('.root-link[data-index="' + idx + '"]');
          if (left) {
            left.classList.add("active");
            left.setAttribute("aria-pressed", "true");
            root.querySelectorAll(".group-nav-item").forEach(function (li) {
              li.classList.remove("activated");
            });
            left.closest(".group-nav-item") &&
              left.closest(".group-nav-item").classList.add("activated");
          }
        },
        {
          root: contentScroller,
          threshold: [0, 0.25, 0.5, 0.75, 1],
          rootMargin: "0px 0px -70% 0px",
        }
      );
      panels.forEach(function (p) {
        io.observe(p);
      });
    }
    setupObserver();
  }

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    document.querySelectorAll(".category-navigation-page").forEach(init);
  });
})();


